export class UserModulePage {
	private _pageId: string;
	private _activityUrl: string;

	constructor(pageId: string, activityUrl: string) {
		this._pageId = pageId;
		this._activityUrl = activityUrl;
	}

	public get pageId(): string {
		return this._pageId;
	}

	public get activityUrl(): string {
		return this._activityUrl;
	}
}
